import type { Ranges } from 'api/System/types'
import { getDateKey } from 'data/utils'
import type { Action } from 'redux'
import type { RequestDate } from 'types/UI'
import { emptyObject, parseDateForRequest } from 'utils'

import { FETCH_GROUP, FETCH_GROUP_DONE, FETCH_GROUP_ERROR, FETCH_GROUP_SUCCESS } from './constants'
import type { Group as GroupState, GroupResponse } from './types'

interface ReducerAction extends Action {
  payload: {
    data: GroupResponse[]
    dateCurrent: RequestDate
    dateCompared?: RequestDate | null
    errorCode?: number
    range: Ranges
  }
}

export default function Group(state: GroupState = emptyObject, { payload, type }: ReducerAction) {
  switch (type) {
    case FETCH_GROUP:
      return {
        ...state,
        [getDateKey(payload, true)]: {
          ...(state[getDateKey(payload, true)] || emptyObject),
          errorCode: null,
          isLoading: true,
        },
      }
    case FETCH_GROUP_DONE:
      return {
        ...state,
        [getDateKey(payload, true)]: {
          ...(state[getDateKey(payload, true)] || emptyObject),
          isLoading: false,
        },
      }
    case FETCH_GROUP_ERROR:
      return {
        ...state,
        [getDateKey(payload, true)]: {
          errorCode: payload?.errorCode,
          isLoading: false,
        },
      }
    case FETCH_GROUP_SUCCESS:
      return {
        ...state,
        [getDateKey(payload, true)]: {
          data: payload.data,
          fetchTime: parseDateForRequest(moment(), true),
          isLoading: false,
        },
      }
    default:
      return state
  }
}
